export const CHECK_PRIORITY_DELIVERY_START = 'CHECK_PRIORITY_DELIVERY_START';

export const CHECK_PRIORITY_DELIVERY_SUCCESS = 'CHECK_PRIORITY_DELIVERY_SUCCESS';

export const CHECK_PRIORITY_DELIVERY_FAILED = 'CHECK_PRIORITY_DELIVERY_FAILED';
